import { NavLink } from "react-router-dom";
import { IconDetails, IconHome, IconMap, IconMedal } from "./icons";

/* A barra de baixo do desafio.

   O feed é uma aba. Antes não era: as três abas eram Detalhes,
   Classificações e Bate-papo, e a tela onde a pessoa mais fica — o feed —
   não tinha endereço nenhum aqui. Estando nela, NENHUMA aba acendia, e o
   modelo que a barra desenha deixava de bater com o do app. O caminho de
   volta era um ícone de hambúrguer no topo, que promete menu e navegava
   um nível acima.

   Ela é fixa e some sob o conteúdo — por isso toda tela que a mostra
   reserva o espaço dela com `.screen-body` (e quem NÃO a mostra usa
   `.no-tabbar`). Sem essa reserva o último prato do feed fica atrás dos
   botões e ninguém consegue tocar nele. */

const ABAS = [
  /* `end` porque o feed é a rota índice do desafio: sem ele o NavLink
     casaria com `/c/:cid/qualquer-coisa` e a aba Feed ficaria acesa em
     todas as outras. */
  { to: "", label: "Feed", Icone: IconHome, end: true },
  /* "Placar" e não "Classificações": com quatro abas em 390px o rótulo
     longo estoura, e "placar" é a palavra que o app já usa no resto da
     interface ("Ninguém no placar ainda"). */
  { to: "classificacao", label: "Placar", Icone: IconMedal, end: false },
  /* O mapa no lugar do bate-papo.

     O bate-papo ocupava uma das quatro portas do desafio e é o que menos
     se usa — dá pra conversar em qualquer outro lugar, e a maior parte
     dos grupos já conversa. O mapa do grupo não existe em lugar nenhum
     além do Nhomi, e estava escondido dois toques abaixo de Detalhes:
     quem nunca abriu Detalhes nunca soube que o grupo tinha um mapa.

     O bate-papo não sumiu — virou ícone no topo do desafio, ao lado do
     raio do recap, e o aviso de mensagem nova continua abrindo direto
     nele.

     "Mapa" e não "Nosso mapa" pelo mesmo motivo de "Placar": em 390px
     cada aba tem pouco mais de 90px e o rótulo de duas palavras vira
     reticências. O nome inteiro está no topo da tela, onde cabe. */
  { to: "guia", label: "Mapa", Icone: IconMap, end: false },
  { to: "detalhes", label: "Detalhes", Icone: IconDetails, end: false },
];

export function TabBar({ cid }: { cid: string }) {
  return (
    <nav className="tabbar">
      {ABAS.map(({ to, label, Icone, end }) => (
        <NavLink key={to || "feed"} to={to ? `/c/${cid}/${to}` : `/c/${cid}`} end={end}
          className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
          <Icone size={24} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
